module.exports = __webpack_public_path__ + "img/failed-fetch.49b00fa2.png";